export default {
  Projects: {
    Pages: {
      Menu: 'پروژه ها',
    },
  },
}
